<template>
    <div>

        <div class="table_wrap">
            <div class="c_table_wrap table_search_wrap">
                <div class="filter-select-div el-filter-date ">
                    <span class="filter-select-span mr24">개인정보</span>
                    <span class="filter-select-span mr24">
                      <el-select v-model="filterOption" class="select mr5" @change="changeFilter()">
                        <el-option :value="''" :label="'전체'"></el-option>
                        <el-option :value="'reporterNick'" :label="'신고자 닉네임'"></el-option>
                        <el-option :value="'reporterId'" :label="'신고자 아이디'"></el-option>
                        <el-option :value="'reportedNick'" :label="'신고당한 닉네임'"></el-option>
                        <el-option :value="'reportedId'" :label="'신고당한 아이디'"></el-option>
                      </el-select>
                      </span>
                    <el-input
                        class="table_s_input search-input mr5"
                        v-model="searchInput"
                        size=""
                        placeholder="검색어를 입력해주세요."
                        maxLength="40"
                        @keyup.enter.native="runSearch()"
                    >
                    </el-input>
                    <el-button class="search-button" @click="runSearch()">
                      검색
                    </el-button>
                  </div>
            </div>
        </div>
        <div class="has_infinite_loading">
            <declaration-firebase-list-layout
                               :declarationData="List" :paginationData="this.pageData"></declaration-firebase-list-layout>
            <infinite-loading
                @infinite="loadMore" spinner="circles" v-show="!loadingMore"
                v-if="!removeLoading" >
                <span slot="no-more"></span>
                <span slot="no-results"></span>
            </infinite-loading>
        </div>
        
    </div>
</template>

<script>
    import util from "@/mixins/util";
    import firestoreListMixins from "@/mixins/firestoreListMixins";
    import dateMixins from "@/mixins/dateMixins";
    import alertMixins from "@/mixins/alertMixins";
    import {mapState, mapGetters} from "vuex";
    import DeclarationFirebaseListLayout from "@/template/declaration/list/DeclarationFirebaseListLayout";
import EventBus from "@/utils/event-bus";
import {collection, limit, query, startAfter, getDocs, orderBy} from "firebase/firestore";

    let filterConfig = {};

    export default {
        name: "DeclarationFirebaseComponent",
        mixins: [firestoreListMixins,dateMixins, alertMixins],
        components: {
            DeclarationFirebaseListLayout
        },
        inject: ['changeLoading'],
        provide() {
            return{

            }
        },
        props: {
            declarationType:"",
        },
        data() {
            return{
            filterLevel: ['', ''],
            filterOptions: [
                {value: '', name: '전체', dataKey: ''},
                {value: 'reporterNick', name: '신고자 닉네임', dataKey: 'reporterNick', dataValueName: 'searchInput', filterType: '==', setOrder: false,},
                {value: 'reporterId', name: '신고자 아이디', dataKey: 'reporterId', dataValueName: 'searchInput', filterType: '==', setOrder: false,},
                {value: 'reportedNick', name: '신고자 닉네임', dataKey: 'reportedNick', dataValueName: 'searchInput', filterType: '==', setOrder: false,},
                {value: 'reportedId', name: '신고자 아이디', dataKey: 'reportedId', dataValueName: 'searchInput', filterType: '==', setOrder: false,},
            ],
            sortData: {
                type: 'created',
                order: 'desc',
            },
            storeData: [],
                searchInputOption: "reporterNick",
                searchInput:"",
                col:null,
            }
        },
        created() {
            this.setCollection();
            this.setQueryToFilter();
            this.runSearch(true);
            // this.initConfig();
            // this.setFilterConfig(filterConfig)
            // this.setParserType('url', this.$route.fullPath);
        },
        mounted() {
            // this.getList(true);
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
            ...mapState({
                db: state => state.db,
            })
        },
        methods:{
            changeFilter() {
                this.searchInput = "";
            },
            setCollection() {
            this.col = this.db.collection('report').where("roomType", "==","openChat");
        },
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
